// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ZoneZipCode extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  color?: string;
  county?: string;
  deleted?: Date;
  isActive!: boolean;
  primaryCity?: string;
  territory?: string;
  type?: string;
  zipCode?: string;
  zoneNumber?: string;
}

